<div class="question-header">
    <div *ngIf="familiarisationCheck" class="familiarisation-title aa-copy-size"><!-- contents set in _check.scss --></div>
</div>
<div class="preload" id="js-preload-div">
  <div>
    <p id="js-loading" class="font-large text-center aa-lead-size">
      Question {{question.sequenceNumber}}&hellip;
    </p>
    <button *ngIf="config.nextBetweenQuestions && nextButtonDelayFinished"
      type="button"
      class="item-center button button-start aa-button-size aa-contrast-button aa-button-center"
      id="goButton"
      (click)="sendTimeoutEvent()">
      Next
    </button>
  </div>
</div>
<ng-container #modalContainer></ng-container>
